import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const ColumnChart = ({ headerText, smallText, xaxisText, yaxisText, amount, accountNumber, count, commission }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if the data arrays are valid and log them for debugging

    if (
      Array.isArray(count) && count.length > 0 &&
      Array.isArray(accountNumber) && accountNumber.length > 0 &&
      Array.isArray(amount) && amount.length > 0 &&
      Array.isArray(commission) && commission.length > 0
    ) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, [count, amount, accountNumber, commission]);

  const chartData = {
    series: [
      {
        name: "Sales",
        data: amount || [], // Default to empty array if amount is undefined
      },
      {
        name: "Commission",
        data: commission || [], // Default to empty array if commission is undefined
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      legend: {
        show: false,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "1%",
          borderRadius: 4,
          borderRadiusApplication: "end"
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 14,
        colors: ["transparent"],
      },
      xaxis: {
        categories: accountNumber || [], // Default to empty array if accountNumber is undefined
        labels: {
          rotate: -50,
          rotateAlways: true,
          trim: true,
          style: {
            colors: "grey",
            fontSize: "13px",
          },
          formatter: function (val) {
            return val;
          },
        },
        title: {
          display: true,
          text: xaxisText,
          style: {
            color: "grey",
            fontSize: "13px",
            fontWeight: "normal",
          },
        },
        axisBorder: {
          show: true,
        },
        axisTicks: {
          show: false,
        },
        crosshairs: {
          fill: {
            gradient: {
              opacityFrom: 0,
              opacityTo: 0,
            },
          },
        },
      },
      yaxis: {
        title: {
          display: true,
          text: yaxisText,
          style: {
            color: "grey",
            fontSize: "13px",
            fontWeight: "normal",
          },
        },
        axisBorder: {
          show: true,
        },
        axisTicks: {
          show: false,
        },
        crosshairs: {
          fill: {
            gradient: {
              opacityFrom: 0,
              opacityTo: 0,
            },
          },
        },
      },
      fill: {
        colors: ["#f57ea4", "#42a1d1"],
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
      grid: {
        yaxis: {
          lines: {
            show: false,
          },
        },
      },
    },
  };

  return (
    <>
      <div className="card">
        <div className="card-header header-elements pb-3">
          <div>
            <h5 className="card-title mb-0">{headerText}</h5>
            <small className="text-muted">{smallText}</small>
          </div>
        </div>
        {isLoading ? (
          <div className="px-3 py-3">
            <h5>Loading.....</h5>
          </div>
        ) : (
          <div className="card-body pt-0">
            <div id="chart">
              {amount.length > 0 && commission.length > 0 && accountNumber.length > 0 ? (
                <ReactApexChart
                  options={chartData.options}
                  series={chartData.series}
                  type="bar"
                  height={350}
                />
              ) : (
                <p>No data available</p>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ColumnChart;
